export enum UserStatusEnum {
  Denied = -100,
  Waiting = -10,
  Blocked = -1,
  Pending = 0,
  Accepted = 100,
}
